import axios from './ConfiguredAxios';
import App from 'PublicJs/App';

const Lists = {

	cachedLists: null,

	getLists: function() {
		/*
		if (this.cachedLists !== null) {
			return new Promise(() => {
				return this.cachedLists;
			});
		}
		*/
		return axios.get(App.getLocale() + '/static-lists').then(result => {
			this.cachedLists = result.data;

			return result;
		});
	},
};

export default Lists;
